import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/authProvider";
import LoadingBalls from "./loadingBalls";

export const customerTermsVersion = "v1.0";

export default function CustomerTerms({ term }: { term?: { [key: string]: any } | null }) {

    const { setTermsAccepted, logOut } = useAuth();

    const [acc, setAcc] = useState(false);
    const [loading, setLoading] = useState(false);


    const acceptTerms = async () => {
        try {
            setLoading(true);
            await setTermsAccepted(term?.version);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    return (
        <main className="fixed inset-0 bg-primary z-[9999] overflow-y-auto pt-24 pb-16 px-4">
            <div className="max-w-3xl mx-auto animate-superfade">
                {/* Header */}
                <div className="text-center mb-12">
                    <p className="text-secondary font-bold tracking-[0.4em] text-[10px] uppercase mb-4">Informação Legal</p>
                    <h1 className="font-outfit text-3xl md:text-5xl font-black text-white tracking-widest uppercase mb-4">
                        {term?.title || "Termos de Uso"}
                    </h1>
                    <div className="w-16 h-1 bg-secondary mx-auto rounded-full mb-6" />
                    <p className="text-white/60 text-xs font-bold tracking-widest uppercase">
                        {term?.version} {term?.updatedAt ? `• ATUALIZADO EM ${new Date(term?.updatedAt).toLocaleDateString("pt-br")}` : null}
                    </p>
                </div>

                {/* Content Box */}
                <div className="bg-white rounded-[2rem] p-4 md:p-6 shadow-2xl shadow-black/20 border border-white/10 mb-10 overflow-hidden relative">
                    <div className="absolute top-0 left-0 w-full h-2 bg-secondary" />
                    <div className="prose prose-slate max-w-none p-4 md:p-6 max-h-[600px] overflow-y-scroll">
                        <div className="text-primary/80 leading-relaxed text-sm md:text-base space-y-6 whitespace-pre-wrap font-medium">
                            {term?.term}
                        </div>
                    </div>
                </div>

                {/* Accept Actions */}
                {
                    term ?
                        <div className="space-y-8">
                            <label className="flex items-start gap-4 cursor-pointer group max-w-2xl mx-auto px-4">
                                <div className="relative pt-1">
                                    <input 
                                        id="acc" 
                                        type="checkbox" 
                                        className="sr-only" 
                                        checked={acc} 
                                        onChange={() => setAcc(!acc)} 
                                    />
                                    <div className={`w-6 h-6 rounded border-2 transition-all flex items-center justify-center ${acc ? "bg-secondary border-secondary shadow-lg shadow-secondary/20" : "border-white/20 group-hover:border-secondary"}`}>
                                        {acc && (
                                            <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.5 6L4.5 8L9.5 3.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        )}
                                    </div>
                                </div>
                                <span className="text-white/80 text-sm font-medium leading-relaxed group-hover:text-white transition-colors">
                                    Ao prosseguir, declaro que li e aceito os Termos de Uso e a <Link className="text-secondary font-bold hover:underline" to="/politica-de-privacidade">Política de Privacidade</Link> do GMT-3.
                                </span>
                            </label>

                            <div className="flex justify-center">
                                <button 
                                    onClick={acceptTerms} 
                                    disabled={!acc || loading || !term} 
                                    className="px-12 py-5 bg-secondary text-white font-black tracking-[0.2em] text-xs rounded-2xl hover:bg-secondary/90 transition-all shadow-xl shadow-black/20 hover:scale-105 active:scale-95 disabled:bg-white/10 disabled:text-white/20 disabled:scale-100 disabled:shadow-none min-w-[240px]"
                                >
                                    {
                                        loading ?
                                            <div className="w-fit m-auto">
                                                <LoadingBalls width={30} color="#fff" />
                                            </div>
                                            :
                                            "ACEITAR E PROSSEGUIR"
                                    }
                                </button>
                            </div>
                        </div>
                        :
                        <div className="bg-red-500/10 border border-red-500/20 rounded-2xl p-6 text-center flex flex-col items-center gap-6">
                            <p className="text-red-400 font-bold tracking-wide text-sm uppercase">Não foi possível carregar os Termos de Uso. Tente novamente mais tarde ou entre em contato com o suporte.</p>
                            <button
                                onClick={logOut}
                                className="px-8 py-3 border-2 border-white/20 text-white font-black tracking-widest text-xs rounded-xl hover:bg-white/10 transition-all active:scale-95"
                            >
                                SAIR DA CONTA
                            </button>
                        </div>
                }
            </div>

            {/* Background Hint */}
            <div className="fixed top-0 right-0 w-[500px] h-[500px] bg-secondary/[0.05] rounded-full blur-[120px] -z-10 pointer-events-none" />
            <div className="fixed bottom-0 left-0 w-[300px] h-[300px] bg-white/[0.02] rounded-full blur-[100px] -z-10 pointer-events-none" />
        </main>
    )
}
